import { render, staticRenderFns } from "./PrivacyMay2020.vue?vue&type=template&id=39e213cc&scoped=true"
import script from "./PrivacyMay2020.vue?vue&type=script&lang=js"
export * from "./PrivacyMay2020.vue?vue&type=script&lang=js"
import style0 from "./PrivacyMay2020.vue?vue&type=style&index=0&id=39e213cc&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e213cc",
  null
  
)

export default component.exports